import React, { useEffect } from 'react'
import StpdBannerComponent from 'stpd-ad-component'
import PropTypes from 'prop-types'
import config from 'SRC/config/config.yaml'


export const Banners = ({ currentImage }) => {
  useEffect(() => {
    if (window.slots?.['oglasi_me_desk_160x600_d']) {
      setTimeout(() => {
        googletag.cmd.push(function () { googletag.pubads().refresh([window.slots['oglasi_me_desk_160x600_d']]); });
      }, 1000)
    }

    if (window.slots?.['oglasi_me_desk_160x600_e']) {
      setTimeout(() => {
        googletag.cmd.push(function () { googletag.pubads().refresh([window.slots['oglasi_me_desk_160x600_e']]); });
      }, 2000)
    }
  }, [currentImage])

  return (
    <React.Fragment>
      <div key='banner-left' className='banner-left'>
        <div style={{ width: 160, height: 600 }}>
          <StpdBannerComponent
            refreshOnUrlChange={true}
            adUnitPath={`/${config.banners.dfpNetworkId}/${config.banners.adImages.left.adUnit}`}
            size={config.banners.adImages.left.sizes}
            divId={config.banners.adImages.left.slotId}
          />
        </div>
      </div>

      <div key='banner-right' className='banner-right'>
        <div style={{ width: 160, height: 600 }}>
          <StpdBannerComponent
            refreshOnUrlChange={true}
            adUnitPath={`/${config.banners.dfpNetworkId}/${config.banners.adImages.right.adUnit}`}
            size={config.banners.adImages.right.sizes}
            divId={config.banners.adImages.right.slotId}
          />
        </div>
      </div>
    </React.Fragment>
  )
}

Banners.propTypes = {
  currentImage: PropTypes.number.isRequired
}
